import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Network, AlertCircle } from 'lucide-react';
import { useLocation } from 'react-router-dom';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const message = location.state?.message;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await signIn(email, password);
      navigate('/dashboard');
    } catch (err) {
      setError('Failed to sign in');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-dark-900 px-4">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <Network className="mx-auto h-12 w-12 text-primary-500" />
          <h2 className="mt-6 text-3xl font-bold text-white">Sign in to NRM</h2>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          {error && <div className="text-red-500 text-center">{error}</div>}
          {message && (
            <div className="bg-green-500/10 border border-green-500/20 text-green-500 p-4 rounded-lg text-center flex items-center justify-center gap-2">
              <AlertCircle className="w-4 h-4" />
              {message}
            </div>
          )}
          <div className="space-y-4">
            <div>
              <label htmlFor="email" className="sr-only">
                Email address
              </label>
              <input
                id="email"
                name="email"
                type="email"
                required
                className="input w-full"
                placeholder="Email address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div>
              <label htmlFor="password" className="sr-only">
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                required
                className="input w-full"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          <div>
            <button type="submit" className="btn btn-primary w-full">
              Sign in
            </button>
          </div>
        </form>
        <div className="space-y-4 text-center">
          <div>
            <Link to="/reset-password" className="text-primary-500 hover:text-primary-400">
              Forgot your password?
            </Link>
          </div>
          <div>
            <Link to="/register" className="text-primary-500 hover:text-primary-400">
              Need an account? Register
            </Link>
          </div>
          <div className="text-sm text-gray-400">
            By signing in, you agree to our{' '}
            <Link to="/terms" className="text-primary-500 hover:text-primary-400">Terms of Service</Link>
            {' '}and{' '}
            <Link to="/privacy_policy" className="text-primary-500 hover:text-primary-400">Privacy Policy</Link>
          </div>
          <div className="text-sm text-gray-400">
            Questions? Contact{' '}
            <a href="mailto:contact@neosavvy.com" className="text-primary-500 hover:text-primary-400">
              contact@neosavvy.com
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}